import React from 'react'
import AttachmentsList from 'components/AttachmentsList'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayProcesses(props) {
  const { questionData: answerData } = props
  const classes = styles()

  const buildProcess = (processInfo) => {
    return (
      <div className={classes.answersContainer} key={processInfo.key}>
        <p>
          <span>Número do processo: </span>
          {processInfo.number}
        </p>
        {processInfo?.attachments?.length > 0 ? (
          <AttachmentsList attachments={processInfo.attachments} />
        ) : null}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento dos processos:</h3>
      <DisplayAnswerItems
        answerData={answerData}
        noDataMessage="O assessor informou que não consta em nenhuma mídia negativa."
        funcBuildItem={buildProcess}
      />
    </div>
  )
}

export default DisplayProcesses
